// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"35e6323a","373":"d9837ed1","616":"e7b1d83b","693":"c39e3ee2","835":"97069230","974":"fa46085c","983":"2ef51099"}[chunkId] + ".chunk.js";
};